module.exports = __webpack_public_path__ + "static/media/DaxlinePro-Regular.c3cb9a89.woff";